import { ThemeOptions } from '@mui/material/styles'

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff5277',
    },
    secondary: {
      main: '#f50057',
    },
  },
}
